import {NextPage} from 'next';

import {useVerifyPendingQuery} from '#apollo/schema';
import {Screen} from '#component/base';
import {VerifySuccess} from '#component/page/VerifySuccess';
import {useAuth} from '#hook';
import {sprinkles} from '#style/sprinkles';

import {VerifyPendingAuthed} from './component/VerifyPendingAuthed';
import {VerifyPendingUnauthed} from './component/VerifyPendingUnauthed';

/**
 * `VerifyPending` is the screen shown when the user has not verified their
 * account. If a user is authenticated but not verified, they should be
 * redirected to the corresponding route for this component ('/verifyaccount').
 */
export const VerifyPending: NextPage = () => {
  const {isUserSignedIn} = useAuth();
  const authenticated = isUserSignedIn();
  const {data, loading} = useVerifyPendingQuery({skip: !authenticated});
  const {me} = data || {};
  const {userProfile, isVerified} = me || {};
  const {email} = userProfile || {};

  return (
    <Screen
      contentContainerClassName={sprinkles({
        flex: 'flex',
        content: ['end', 'end', 'center'],
        dir: 'col',
      })}
      loading={loading}
      pageName="Verify account"
      sidePanelImageUrl="/image/verify-account.jpg">
      <div
        className={sprinkles({
          direction: 'col',
          flex: 'flex',
          height: 'full',
          placeContent: ['end', 'center'],
        })}>
        {isVerified ? (
          <VerifySuccess authenticated />
        ) : authenticated ? (
          <VerifyPendingAuthed email={email} />
        ) : (
          <VerifyPendingUnauthed />
        )}
      </div>
    </Screen>
  );
};
